import {ApiError} from '@pocketbuy/outdoor-api-client';

export function pickupError(error:unknown,online:boolean):'OFFLINE'|'MISMATCH'|'SERVER'{
 const e=error as {response?:{status?:number;data?:{message?:string}};isAxiosError?:boolean;message?:string};
 // ApiError is a received business/server response, not an Axios transport error.
 const received=error instanceof ApiError||Boolean(e?.response);
 if(!received&&(!online||e?.isAxiosError))return 'OFFLINE';
 const status=error instanceof ApiError?error.status:e?.response?.status;
 if(status&&status>=500)return 'SERVER';
 const message=error instanceof ApiError?error.message:e?.response?.data?.message;
 return message&&/imei|match|device|sku|phone/i.test(message)?'MISMATCH':'SERVER';
}
